module.exports = __webpack_public_path__ + "img/location-delegate-icon.0611e3c3.svg";